import gql from 'graphql-tag';

export const GET_INSURANCE_QUOTE_BY_VENDOR_OPPORTUNITY_ID = gql`
  query ($vendorOpportunityId: ID!) {
    insuranceQuote {
      insuranceQuoteByVOId(vendorOpportunityId: $vendorOpportunityId) {
        success
        error
        entity {
          insuranceQuoteId
          vendorOpportunityId
          taskId
          insuranceProvider
          inputValue
          status
          insuranceCoverage {
            coverageRequirements
            certificateRequirements
            otherInstructions
          }
        }
      }
    }
  }
`;

export const GET_CREDIT_SUBMISSIONS = gql`
  query CreditSubmissionsByDynamicsVOId($id: ID!, $display: String) {
    creditSubmissionsByDynamicsVOId(id: $id, display: $display) {
      creditSubmissionId
      creditSubId
      submissionDate
      decision
      lenderName
      amountRequested
      approvedAmount
      notes
      contingencies
      approvedRate
      creditSubStage
      apiApplicationId
      apiResult
      apiExpiredCredentials
      apiDetail
      lenderProfileId
      dynamicsLenderProfileId
      lenderChannelCode
      lenderTypeCode
      draft
      creditSubStage
      transactionSummary
      mappedValues
      source
      submittedBy
      lenderContactInfo {
        id
        email
        dynamicsContactId
        fullName
        title
        phoneNumber
        accountId
      }
    }
  }
`;

export const GET_FINANCE_PROGRAMS = gql`
  query GetFinancePrograms($accountId: ID!, $lenderProfileIds: [ID]) {
    financePrograms(accountId: $accountId, lenderProfileIds: $lenderProfileIds) {
      accountId
      financeProgramId
      nameInternal
      validDateEnd
      validDateStart
      createdDateTime
      modifiedDateTime
      insuranceCoverage {
        coverageRequirements
        certificateRequirements
        otherInstructions
      }
      financeProgramToLenderProfiles {
        lenderProfileId
        financeProgramToLenderProfileId
        createdDateTime
        modifiedDateTime
        isDisabled
      }
    }
  }
`;

export const Q_CREDIT_APP_REFERENCES = gql`
  query CreditApplicationReferences($id: ID!) {
    creditApplication(id: $id) {
      id
      dynamicsId
      references {
        referenceId
        companyName
        contactName
        contactPhone
        accountNum
        originalLoanAmt
        percRevenue
        years
        months
        lineOfCredit
        creditLimit
        currentBalance
        monthlyPayment
        renewalDate
        referenceType
        contactEmail
        contactFax
        address
        city
        state
        zip
        county
        jobTitle
        startDate
        endDate
        industry
        salary
        monthlyRevenue
        paidPerMile
        percentGross
        averageBalance
        yearMakeModel
        paidOff
        trade
        securedBy
        physicalDamageDeduction
        liabilityCoverage
        productType
        okayToContact
        driverType
        futureEmployerSameAsCurrent
        monthlyMiles
        taxId
        yearBusinessEstablished
        custom1
        custom2
        custom3
        referenceIdx
        ownerId
      }
    }
  }
`;

export const QUERY_TASKS = gql`
  query VendorOpportunityTask($VOId: ID!) {
    vendorOpportunityTask(VOId: $VOId) {
      taskId
      vendorOpportunityId
      regarding
      status
      assignedToUserProfileId
      assignedToAccountId
      assignedByUserProfileId
      assignedByAccountId
      notes
      priority
      createdBy
      completedDateTime
      dueDateTime
      createdDateTime
      assignedByUser
      assignedByAccount
      assignedToUser
      assignedToAccount
      notifyByEmail
      notifyByText
      notifyAssignorOnReminder
      notificationContactIds
      lastReminderSent
      nextReminder
      assignedToApplicant
      assignedBySystem
      ownerPgId
      financeProgramId
      creditSubId
      completionData {
        name
        title
        signature
        additionalInformation
      }
      taskItems {
        taskItemId
        type
        docType
        taskAssignorNotes
        taskAssigneeNotes
        doc {
          documentId
          vendorOpportunityId
          source
          docType
          docDescription
          createdBy
          docName
        }
      }
      reference {
        referenceId
      }
    }
  }
`;

export const Q_DOCS = gql`
  query Documents($docId: ID, $VOId: ID) {
    documents(docId: $docId, VOId: $VOId) {
      documentId
      vendorOpportunityId
      source
      docType
      docDescription
      createdBy
      createdDateTime
      docName
      taskItemId
      creditSubmissionId
      notifiedUserProfileIds
      notifiedUserProfiles {
        id
        fullName
        title
      }
      documentCreditSubmission {
        creditSubmissionId
        lenderAccess
      }
    }
  }
`;

export const QUERY_ACTIVE_OCA_TEMPLATE = gql`
  query ActiveOCATemplate($vendorProfileId: ID!, $isActive: Boolean) {
    getOcaTemplatesByVendorProfile(vendorProfileId: $vendorProfileId, isActive: $isActive) {
      ocaTemplateId
      name
      jsonDefinition
      active
    }
  }
`;

export const DEACTIVATE_DOC = gql`
  mutation ($id: ID!) {
    deactivateDocument(id: $id)
  }
`;

export const UPDATE_INSURANCE_QUOTE = gql`
  mutation UpdateInsuranceQuote($input: UpdateInsuranceQuoteInput!) {
    insuranceQuote {
      updateInsuranceQuote(input: $input) {
        success
        error
        entity {
          insuranceQuoteId
          vendorOpportunityId
          taskId
          insuranceProvider
          inputValue
          status
          insuranceCoverage {
            coverageRequirements
            certificateRequirements
            otherInstructions
          }
        }
      }
    }
  }
`;

export const UPDATE_FINANCE_PROGRAM = gql`
  mutation UpdateFinanceProgram($input: UpdateFinanceProgramInput!) {
    updateFinanceProgram(input: $input) {
      accountId
      financeProgramId
      nameInternal
      validDateEnd
      validDateStart
      createdDateTime
      modifiedDateTime
      insuranceCoverage {
        coverageRequirements
        certificateRequirements
        otherInstructions
      }
      financeProgramToLenderProfiles {
        lenderProfileId
        financeProgramToLenderProfileId
        createdDateTime
        modifiedDateTime
        isDisabled
      }
    }
  }
`;

export const UPDATE_CREDIT_APPLICATION_V2_QUERY = gql`
  mutation ($creditAppId: ID!, $input: UpdateCreditApplicationV2Input!) {
    updateCreditApplicationV2(creditAppId: $creditAppId, input: $input)
  }
`;

export const UPLOAD_FILE = gql`
  mutation ($input: UpsertDocumentInput!, $file: Upload) {
    upsertDocument(input: $input, file: $file)
  }
`;

export const UPDATE_DOCUMENTS_LENDER_ACCESS = gql`
  mutation ($batchUpdateLenderDocumentAccessInput: BatchUpdateLenderDocumentAccessInput!) {
    updateLenderDocumentsAccess(input: $batchUpdateLenderDocumentAccessInput) {
      success
      errorMessage
    }
  }
`;

export const CAMUNDA_START_PROCESS = gql`
  mutation CamundaStartProcess($input: CamundaStartProcessInput!) {
    camundaStartProcess(input: $input)
  }
`;
